import * as events from '@/lib/events.ts';
import { readable } from 'svelte/store';

type CounterMessage = {
	eventName: string;
	payload: CounterPayload;
};

/**
 * As defined in notifications-frontend.
 * https://bitbucket.org/derstandard/notifications-frontend/src/main/src/global.d.ts
 */
type CounterPayload = {
	hasNewNotifications: boolean;
	unreadCount: number;
};

type NotificationStore = {
	hasNewNotifications: boolean;
	unreadCount: number;
};

export default readable<NotificationStore>(
	{
		hasNewNotifications: false,
		unreadCount: 0,
	},
	(set) => {
		window.addEventListener('message', handleMessage);

		/**
		 * Handle the "CounterMessage" event used to show/update the counter.
		 * @param event The message event.
		 */
		function handleMessage(event: MessageEvent<CounterMessage>) {
			if (event?.data?.eventName !== events.dst.notifications.counter || !event?.data?.payload) {
				return;
			}

			const { hasNewNotifications, unreadCount } = event.data.payload;

			set({
				hasNewNotifications: hasNewNotifications ?? false,
				unreadCount: unreadCount ?? 0,
			});
		}

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	},
);
